import { formatScheduleDateKey } from '../../../utils/formatScheduleDateKey';

import type { ScheduleState } from '../types';

type SelectDateByDateKeyParams = {
  dateKey: string;
};

const selectDateByDateKey = (state: ScheduleState, { dateKey }: SelectDateByDateKeyParams) => {
  const formattedDate = formatScheduleDateKey(dateKey);
  return state.schedule.dates[formattedDate];
};

export { selectDateByDateKey };
